export default __webpack_public_path__ + "static/media/turistas-felices-faro-isla-aillaquillen.94f5cb91.jpeg";